import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M15.737 16.5v-6.177M9 16.5V7.676M2.263 16.5v-3.53m7.922-9.681 4.352 1.71M7.988 3.62 3.274 7.322M16.63 4.535a1.37 1.37 0 0 1 0 1.871 1.223 1.223 0 0 1-1.786 0 1.37 1.37 0 0 1 0-1.871 1.223 1.223 0 0 1 1.786 0M3.156 7.182a1.37 1.37 0 0 1 0 1.872 1.223 1.223 0 0 1-1.786 0 1.37 1.37 0 0 1 0-1.872 1.223 1.223 0 0 1 1.786 0m6.737-5.294a1.37 1.37 0 0 1 0 1.871 1.223 1.223 0 0 1-1.786 0 1.37 1.37 0 0 1 0-1.871 1.223 1.223 0 0 1 1.786 0"
    }, null, -1)
  ]))]))
}
export default { render: render }